import React from "react"

import {AsyncImage} from "../controls"
import "./Kitchensink.scss"

function Spacer() {
  return <div className="kitchensink-spacer"></div>
}

function Kitchensink() {
  return (
    <div id="v-kitchensink">
      <Spacer />
      <AsyncImage className="asyncimage-test" src="http://thegincooperative.com/wp-content/uploads/2018/04/gin-isle-of-skye-distillers-header.jpg" alt="test" />
      <Spacer />
      <h1>Heading1 (h1)</h1>
      <Spacer />
      <h2>Heading2 (h2)</h2>
      <Spacer />
      <h3>Heading3 (h3)</h3>
      <Spacer />
    </div>
  )
}

export default Kitchensink